import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth';
import cookie from 'vue-cookies';
import { PORTAL_POOL } from '@/utils/const';

const AGENT_KEY = 'agent';
const CUSTOMER_KEY = 'customer';

export function isAgentPool(config) {
  return config && config.aws_resource_name === process.env.VUE_APP_AGENT_POOL_RESOURCE_NAME;
}

export function poolKeyFromConfig(config) {
  return isAgentPool(config) ? AGENT_KEY : CUSTOMER_KEY;
}

export function resolveInitialPool(configurations, route) {
  const list = configurations || [];
  const agentConfig = list.find((c) => isAgentPool(c)) || list[1];
  const customerConfig = list.find((c) => !isAgentPool(c)) || list[0];

  const queryPortal = (route && route.query && route.query.portal) || '';
  if (queryPortal === AGENT_KEY) return agentConfig;
  if (queryPortal === CUSTOMER_KEY) return customerConfig;

  const saved = cookie.get(PORTAL_POOL);
  if (saved === AGENT_KEY) return agentConfig;
  if (saved === CUSTOMER_KEY) return customerConfig;

  return customerConfig;
}

export function persistPortalPool(config) {
  cookie.set(PORTAL_POOL, poolKeyFromConfig(config));
}

export function portalQueryFromConfig(config) {
  return { portal: poolKeyFromConfig(config) };
}

export function mergePortalQuery(routeQuery, config) {
  return { ...routeQuery, ...portalQueryFromConfig(config) };
}

/** Use saved customer/agent pool so Auth.currentSession() targets the right Cognito pool after reload. */
export function configureAmplifyForSavedPool(configurations) {
  const pool = resolveInitialPool(configurations, null);
  if (pool) {
    Amplify.configure(pool);
    Auth.configure(pool);
  }
}
